/* eslint-disable complexity */
import React from 'react';
import classNames from 'classnames';

import styles from './filter.scss';
import { FILTER_TYPE, SORT, TABLE_COLUMN } from '../filter-table-types';
import { useIntl } from 'react-intl';

interface SortLabelProps {
  activeColumn: TABLE_COLUMN;
  sortByColumn?: TABLE_COLUMN;
  handleSortClick: (sort: SORT) => void;
  sort?: SORT;
  filterType?: FILTER_TYPE;
}

export const SortLabel = ({ activeColumn, sortByColumn, handleSortClick, sort, filterType }: SortLabelProps) => {
  const intl = useIntl();
  const isActiveAscSort = activeColumn && sortByColumn && activeColumn === sortByColumn && sort === SORT.ASC;

  const isActiveDescSort = activeColumn && sortByColumn && activeColumn === sortByColumn && sort === SORT.DESC;

  let ascSortLabel = intl.formatMessage({ id: 'common.sort_a_to_z', defaultMessage: 'Sort A → Z' });
  let descSortLabel = intl.formatMessage({ id: 'common.sort_z_to_a', defaultMessage: 'Sort Z → A' });
  if (filterType === FILTER_TYPE.NUMBER) {
    ascSortLabel = intl.formatMessage({ id: 'common.sort_low_to_high', defaultMessage: 'Sort Low → High' });
    descSortLabel = intl.formatMessage({ id: 'common.sort_high_to_low', defaultMessage: 'Sort High → Low' });
  }
  if (filterType === FILTER_TYPE.DATE || filterType === FILTER_TYPE.TIME) {
    ascSortLabel = intl.formatMessage({ id: 'common.sort_early_to_late', defaultMessage: 'Sort Earliest → Latest' });
    descSortLabel = intl.formatMessage({ id: 'common.sort_late_to_early', defaultMessage: 'Sort Latest → Earliest' });
  }

  return (
    <>
      <div
        className={classNames(styles.sortContainer, {
          [styles.inactiveSort]: !isActiveAscSort
        })}
        style={{ marginBottom: 12 }}
        onClick={() => handleSortClick(SORT.ASC)}
      >
        {ascSortLabel}
      </div>
      <div
        className={classNames(styles.sortContainer, {
          [styles.inactiveSort]: !isActiveDescSort
        })}
        style={{ marginBottom: 16 }}
        onClick={() => handleSortClick(SORT.DESC)}
      >
        {descSortLabel}
      </div>
    </>
  );
};
